interface ShouldUseRankingInfoProps {
  adOps?: boolean
  aroundLatLng?: boolean
  aroundLatLngViaIP?: boolean
}

export const shouldUseRankingInfo = ({
  adOps,
  aroundLatLng,
  aroundLatLngViaIP
}: ShouldUseRankingInfoProps): boolean =>
  [adOps, aroundLatLng, aroundLatLngViaIP].some(Boolean)
